import React from 'react'
import LocalizedStrings from 'react-localization'
import { localisedText } from '../../../lib/localisation.es6'
import HomePageCta from './HomePageCta'

class HomePageCtaContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      labels: new LocalizedStrings(localisedText)
    }
  }

  render() {
    return <HomePageCta {...this.props} labels={this.state.labels} />
  }
}

export default HomePageCtaContainer
